import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { setReset, setStepIndex } from '../../reducers/guideTour';
import { useCookies } from 'react-cookie';
import Step1 from './Step1'
import Step2 from './Step2';
import Step3 from './Step3';
import { getCurrentUserInfo } from 'src/reducers/users/currentUser';
import { useTutorialContext } from './TutorialProvider';

const JoyrideTour = ({ clientPayrollRulesGroups, clientAllowances, payrollRulesGroup, clientUnitPrices, values, currentUser }) => {
  const [cookie] = useCookies(['tutorial'])
  const { getAllTutorial } = useTutorialContext()
  const [tutorialStep1, setTutorialStep1] = useState()
  const [tutorialStep2, setTutorialStep2] = useState()
  const [tutorialStep3, setTutorialStep3] = useState()


  useEffect(() => {
    const allTutorial = getAllTutorial(currentUser.email)
    if (allTutorial) {
      const { tutorialStep1, tutorialStep2, tutorialStep3 } = allTutorial
      setTutorialStep1(tutorialStep1)
      setTutorialStep2(tutorialStep2)
      setTutorialStep3(tutorialStep3)
    }
  }, [cookie['tutorial']])

  return (
    <React.Fragment>
      {tutorialStep1 && <Step1 tutorialStep1={tutorialStep1} />}
      {tutorialStep2 && <Step2 clientPayrollRulesGroups={clientPayrollRulesGroups}
        clientAllowances={clientAllowances} payrollRulesGroup={payrollRulesGroup}
        clientUnitPrices={clientUnitPrices} values={values} tutorialStep2={tutorialStep2} />}
      {tutorialStep3 && <Step3 values={values} tutorialStep3={tutorialStep3} />}
    </React.Fragment>
  );
};

const mapStateToProps = state => ({
  // stepIndex: state.UI.stepIndex,
  currentUser: getCurrentUserInfo(state),

  // run: state.UI.run
});

export default connect(mapStateToProps)(JoyrideTour);
